export class TCPDATA {
    ID: number;
    VQuad_Timestamp: Date;
    Start_Timestamp: Date;
    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;
    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;
    Start_GPS_Position: string;
    Start_GPS_Lat: number;
    Start_GPS_Long: number;

    Net_Speed_Test: string;
    Battery_Level: number;
    RSSI: number;
    Network_Type: string;
    TN_Number: string;

    Target_Server: string;
    TestStatus: string;
  
    Equilibrium_Efficiency: string;
    Capacity_Efficiency: string;
    RTT_Consistency: string;
    Buffer_Delay: string;
    Error_Delay: string;
    Quality: string;
    Dwn_Speed: number;
    Dwn_Effective_Speed: number;
    Dwn_Max_Delay: number;
    Dwn_QOS_TCP: number;
    Dwn_MTU: number;
    Dwn_Retransmit_Timeouts: number;
    Dwn_Fast_Retransmits: number;
    Dwn_Packets_Retransmitted: number;
    Dwn_Bytes_Retransmitted: number;
    Dwn_Send_Window_Closed: number;
    Dwn_Window_Only_Updates_Rcvd: number;
    Dwn_Acks_for_Unsent: number;
    Dwn_Duplicate_Acks: number;
    Dwn_Window_Probes_Sent: number;
    Dwn_Persist_Timeouts: number;
    Dwn_Avg_Delay: number;
    Up_Speed: number;
    Up_Effective_Speed: number;
    Up_Max_Delay: number;
    Up_QOS_TCP: number;
    Up_MTU: number;
    Up_Out_of_Order_Pkt: number;
    Up_Out_of_Order_Byt: number;
    Up_Outside_Window_Pkt: number;
    Up_Outside_Window_Byt: number;
    Up_Pure_Duplicate_Pkt: number;
    Up_Pure_Duplicate_Byt: number;
    Up_Partial_Duplicate_Pkt: number;
    Up_Partial_Duplicate_Byt: number;
    Up_Packets_with_CRC_Error: number;
    Up_Packets_with_Bad_Offset: number;
    Up_Truncated_Packets: number;
    Up_Window_Probes_Received: number;
    Up_Zero_Window_Updates_Sent: number;
    Up_Bytes_Lost: number;
    Up_Avg_Delay: number;
    Max_Route_Speed: number;
    Round_Trip_Time: number;
    No_Of_Sessions: number;
 
    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;

    constructor() {
    this.ID = 0;
    this.VQuad_Timestamp = new Date();
    this.Start_Timestamp = new Date();
    this.Call_Timestamp = new Date();
    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";
    this.GPS_Position = "";
    this.GPS_Lat = 0;
    this.GPS_Long = 0;
    this.Start_GPS_Position = "";
    this.Start_GPS_Lat = 0;
    this.Start_GPS_Long = 0;
  
    this.Net_Speed_Test = "";
    this.Battery_Level = 0;
    this.RSSI = 0;
    this.Network_Type = "";
    this.TN_Number = "";
  
    this.Target_Server = "";
    this.TestStatus = "";
    
    this.Equilibrium_Efficiency = "";
    this.Capacity_Efficiency = "";
    this.RTT_Consistency = "";
    this.Buffer_Delay = "";
    this.Error_Delay = "";
    this.Quality = "";
    this.Dwn_Speed = 0;
    this.Dwn_Effective_Speed = 0;
    this.Dwn_Max_Delay = 0;
    this.Dwn_QOS_TCP = 0;
    this.Dwn_MTU = 0;
    this.Dwn_Retransmit_Timeouts = 0;
    this.Dwn_Fast_Retransmits = 0;
    this.Dwn_Packets_Retransmitted = 0;
    this.Dwn_Bytes_Retransmitted = 0;
    this.Dwn_Send_Window_Closed = 0;
    this.Dwn_Window_Only_Updates_Rcvd = 0;
    this.Dwn_Acks_for_Unsent = 0;
    this.Dwn_Duplicate_Acks = 0;
    this.Dwn_Window_Probes_Sent = 0;
    this.Dwn_Persist_Timeouts = 0;
    this.Dwn_Avg_Delay = 0;
    this.Up_Speed = 0;
    this.Up_Effective_Speed = 0;
    this.Up_Max_Delay = 0;
    this.Up_QOS_TCP = 0;
    this.Up_MTU = 0;
    this.Up_Out_of_Order_Pkt = 0;
    this.Up_Out_of_Order_Byt = 0;
    this.Up_Outside_Window_Pkt = 0;
    this.Up_Outside_Window_Byt = 0;
    this.Up_Pure_Duplicate_Pkt = 0;
    this.Up_Pure_Duplicate_Byt = 0;
    this.Up_Partial_Duplicate_Pkt = 0;
    this.Up_Partial_Duplicate_Byt = 0;
    this.Up_Packets_with_CRC_Error = 0;
    this.Up_Packets_with_Bad_Offset = 0;
    this.Up_Truncated_Packets = 0;
    this.Up_Window_Probes_Received = 0;
    this.Up_Zero_Window_Updates_Sent = 0;
    this.Up_Bytes_Lost = 0;
    this.Up_Avg_Delay = 0;
    this.Max_Route_Speed = 0;
    this.Round_Trip_Time = 0;
    this.No_Of_Sessions = 0;
    
    this.CallType_Orig = "";
    this.CallType_Term = "";
    this.VQuad_CallID = "";
    }
}
